// Yksi totuus Google Maps -konffeille koko appissa

export const GMAPS_KEY =
  (typeof import.meta !== "undefined" ? import.meta.env?.VITE_GOOGLE_MAPS_API_KEY : "") ||
  (typeof process !== "undefined" ? process.env?.REACT_APP_GOOGLE_MAPS_API_KEY : "") ||
  "";

export const USE_GMAPS = !!GMAPS_KEY;
export const GMAPS_LIBS = ["places"];

// Käytä samaa ID:tä kaikkialla
export const GMAPS_ID = "gmaps-core";

// Valitse yksi kieli/alue per sessio (voit vaihtaa myöhemmin, mutta koko appin on noudatettava samaa)
export const GMAPS_LANGUAGE = "fi";
export const GMAPS_REGION = "FI";

// Vie valmiit optionsit useJsApiLoaderille
export const GMAPS_LOADER_OPTIONS = USE_GMAPS
  ? {
      id: GMAPS_ID,
      googleMapsApiKey: GMAPS_KEY,
      libraries: GMAPS_LIBS,
      language: GMAPS_LANGUAGE,
      region: GMAPS_REGION,
    }
  : { id: "gmaps-disabled" };
